import { PropsWithChildren } from 'react'

import LoaderSVG from './LoaderSVG'
import styles from './loaderWrapper.module.scss'

interface ILoaderOverlayWrapper {
  isLoading: boolean
  overlayClasses?: string
}

export const LoaderOverlayWrapper: React.FC<PropsWithChildren<ILoaderOverlayWrapper>> = ({
  overlayClasses = '',
  isLoading,
  children,
}) => {
  const wrapperClasses = overlayClasses ? overlayClasses : styles.loaderOverlay

  return (
    <div className={isLoading ? wrapperClasses : ''}>
      {children}
      <div className={isLoading ? styles.loaderOverlaySurface : 'd-none'} aria-hidden={!isLoading}>
        <LoaderSVG />
      </div>
    </div>
  )
}
